<script>

export default {
  name: 'MainLayout',
  components: {
    MainMag: () => import('./MainMag/MainMag.layout.vue'),
    MainOld: () => import('./MainOld/MainOld.layout.vue'),
  },
  computed: {
    name() {
      return `Main${this.$name}`;
    },
  },
  created() {
    this.$name = 'Old';
  },
};
</script>
<template>
  <component :is="name" v-if="$core.isAuthentication"></component>
</template>
